import type { CartSong } from "./types";

const cartStorageKey = "tunetailor:review-songs";

export function readSavedSongs(): CartSong[] {
  try {
    localStorage.removeItem(cartStorageKey);
    const saved = sessionStorage.getItem(cartStorageKey);
    const parsed = saved ? (JSON.parse(saved) as CartSong[]) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveSongs(songs: CartSong[]): void {
  try {
    sessionStorage.setItem(cartStorageKey, JSON.stringify(songs));
  } catch {
    // The in-memory cart still works when browser storage is unavailable.
  }
}

export function clearSavedSongs(): void {
  try {
    sessionStorage.removeItem(cartStorageKey);
  } catch {
    // Checkout should continue even when browser storage is unavailable.
  }
}
